module.exports = __webpack_public_path__ + "static/media/bg.5eef3ae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/bg.jpg
// module id = 938
// module chunks = 0